import { Platform } from "react-native";

export default {
    colors: {
        primary: "#ABDFF5",
        primary2: "rgba(15, 15, 15, 0.03)",
        secondary: "#1982BE",
        tertiary: "#125176",
        black: "#000",
        white: "#fff",
        medium: "#6e6969",
        light: "#f8f4f4",
        dark: "#0c0c0c",
        danger: "#ff5252",
        yellow: "#ffe66d",
        red: "#ed2b2b",
        green: "#5afc19",
        silver: "silver",
        regPlate: "#fec20a",
        regPlateBlue: "#1e4fb5",
        grey: "#d9d9d9",
    },
    text: {
        // outline: "none",
        color: "#000",
        fontSize: 18,
        fontFamily: Platform.OS === "android" ? "Roboto" : "Avenir",
    },
    boldText: {
        color: "#000",
        fontSize: 18,
        textTransform: "uppercase",
        fontWeight: "bold",
        fontFamily: Platform.OS === "android" ? "Roboto" : "Avenir",
    },
    sizes: {
        titleIconSize: 55,
        listingCardWidth: Platform.OS === "web" ? "50%" : "95%",
        appTextInputWidth: Platform.OS === "web" ? "50%" : "100%",
        appButtonWidth: Platform.OS === "web" ? "50%" : "100%",
    },
    media: {
        logo: require("../assets/logo.jpeg"),
        backgroundImage: require("../assets/background.png"),
    },
    versionNo: "17",
    latestBuildNoAndroid: "1",
    latestBuildNoIos: "1",
    officeLocation: {
        latitude: 53.588108,
        longitude: -2.42731,
    },
};
